import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { ILabsListing } from 'app/models/core/home/labs-listing';
import { Observable } from 'rxjs';
import { ILicenseCashReport } from 'app/models/core/reports/licenseCashReport';
import { IProficiencyReport } from 'app/models/core/reports/proficiencyReport';
import { ISurveyReport } from 'app/models/core/reports/surveyReport';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }),
  withCredentials: true
};

@Injectable({ providedIn: 'root' })

export class ReportsService {
  private api: string = environment.privateApi + 'Reports/';

  public currentTab = 0;

  constructor(private http: HttpClient) {}

  // ***************************** MLicense/Cash Reports ***********************************

  getLicenseCashReportData(month: string, year: string) : Observable<ILicenseCashReport[]> {
    return this.http.get<ILicenseCashReport[]>(this.api + 'getLicenseCashReportData/' +  month + '/' + year
      , { withCredentials: true });
  }

  getLicenseCashReport(reportData: ILicenseCashReport[]): Observable<Blob> {
    return this.http.post<Blob>(this.api + 'getlicenseCashReport', reportData, 
        { responseType: 'blob' as 'json', withCredentials: true });
  }

  getHstNonRenewalReport(): Observable<ILicenseCashReport[]> {
    return this.http.get<ILicenseCashReport[]>(this.api + 'getHstNonRenewalReport', 
        { withCredentials: true });
  }

  licenseCashSoaNonRenewalReport(): Observable<ILicenseCashReport[]> {
    return this.http.get<ILicenseCashReport[]>(this.api + 'licenseCashSoaNonRenewalReport', 
        { withCredentials: true });
  }

  // ***************************** Proficiency Reports ***********************************

  failedProficiencyReport(periods:string): Observable<IProficiencyReport[]> {
    return this.http.get<IProficiencyReport[]>(this.api + 'failedProficiencyReport/' + periods, 
        { withCredentials: true });
  }

  // ***************************** Survey Reports ***********************************

  getSurveyReport(surveyType:string, month:string, year: string, surveyor: string): Observable<ISurveyReport[]> {
    return this.http.get<ISurveyReport[]>(this.api + 'getSurveyReport/' + surveyType
        + '/' + month + '/' + year + '/' + surveyor , 
        { withCredentials: true });
  }

  followUpDoneReport(): Observable<ISurveyReport[]> {
    return this.http.get<ISurveyReport[]>(this.api + 'followUpDoneReport', 
        { withCredentials: true });
  }

  registrationLabsReport(): Observable<ISurveyReport[]> {
    return this.http.get<ISurveyReport[]>(this.api + 'registrationLabsReport', 
        { withCredentials: true });
  }

  deficiencyUnresolvedReport(month:string, year:string, monthEnd:string, yearEnd: string): Observable<ISurveyReport[]> {
    return this.http.get<ISurveyReport[]>(this.api + 'deficiencyUnresolvedReport/' + month + '/' + year + '/' 
        + monthEnd + '/' + yearEnd, 
        { withCredentials: true });
  }

  deficiencyReport(surveyor:string, type:string, month:string, year:string, monthEnd:string, yearEnd: string): 
      Observable<ISurveyReport[]> {
    return this.http.get<ISurveyReport[]>(this.api + 'deficiencyReport/' + surveyor + '/' + type + '/' 
        + month + '/' + year + '/' + monthEnd + '/' + yearEnd, 
        { withCredentials: true });
  }


  // ***************************** Mailing Labels ***********************************

  getMailingLabels(rowOffSet:string, stateNum: string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'getMailingLabels/' + rowOffSet  + '/' + stateNum
    , { responseType: 'blob' as 'json', withCredentials: true });
  }


  getSpecificMailingLabels(rowOffSet:string, labType: string): Observable<Blob> {
    return this.http.get<Blob>(this.api + 'getSpecificMailingLabels/' + rowOffSet  + '/' + labType
    , { responseType: 'blob' as 'json', withCredentials: true });
  }

  // ***************************** Demographics ***********************************

}
